import { render, staticRenderFns } from "./studySource.vue?vue&type=template&id=7637783d"
import script from "./studySource.vue?vue&type=script&lang=js"
export * from "./studySource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports